import React from "react";
import "../../Assets/Styles/Style.css";
const GroupInfo = ({ data }) => (
  <>
    <div className="group-info-row">
      <div className="info-label">Group Name</div>
      <div className="info-value-below">{data.group_info.title}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Description</div>
      <div className="info-value-below">{data.group_info.description}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Start Date</div>
      <div className="info-value-below">{data.group_info.start_date}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">End Date</div>
      <div className="info-value-below">{data.group_info.end_date}</div>
    </div>
    <div className="divider"></div>
    <div className="group-info-row">
      <div className="info-label">Subscription No</div>
      <div className="info-value-below">{data.subscription_no}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Subscription Amount</div>
      <div className="info-value-below">₹{data.group_info.subscription_amt}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Penalty Amount</div>
      <div className="info-value-below">₹{data.group_info.penalty_amt}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Total Month</div>
      <div className="info-value-below">{data.group_info.total_month}</div>
    </div>
  </>
);

export default GroupInfo;
